const trelloAttachmentListReducer = (state = {
    loading:false,
    attachmentList:[],
    totalRecords:0
}, action) => {
    switch (action.type) {
        case "FETCH_TRELLO_ATTACHMENTS":
            return { ...state ,loading:true,attachmentList:[],totalRecords:0}
        case "RECEIVE_TRELLO_ATTACHMENTS":
            return {...state, attachmentList:[...action.payload.data],loading:false,totalRecords:action.payload.totalRecords}
        case "ERROR_TRELLO_ATTACHMENTS":
            return { ...state ,attachmentList:[],loading:false,totalRecords:0}
        default:
            return { ...state }
    }
}

export default trelloAttachmentListReducer;